<template>
	<v-dialog v-if="show" v-model="show" scrollable persistent max-width>
		<v-card :loading="loading">
			<v-card-text class="pt-5">
				<v-row no-gutters justify="center">
					<v-col cols="2">
					</v-col>
					<v-col>
						<v-row no-gutters justify="center">
							<v-btn-toggle
								v-model="pointTechnics"
								borderless
								color="primary"
								multiple
								mandatory
								:disabled="loading"
							>
								<v-btn class="mr-1" small v-for="technic in technics" :key="technic.id" :value="technic.id">
									<v-icon color="primary" small class="mr-1">{{technic.icon}}</v-icon>
									<span>{{technic.name}}</span>
								</v-btn>
							</v-btn-toggle>
						</v-row>
					</v-col>
					<v-col cols="2">
						<v-btn v-if="mode == 'select'" depressed small color="secondary" class="primary--text" :disabled="loading || admin" @click="mode = 'draw'">
							<v-icon color="primary" small class="mr-1">mdi-plus-circle</v-icon>
							<span v-translate>Create Point</span>
						</v-btn>
						<template v-if="mode == 'draw'">
							<span class="primary--text font-weight-medium mr-2" v-translate>Draw the point</span>
							<v-btn depressed small color="secondary" class="primary--text" :disabled="loading" @click="mode = 'select'">
								<v-icon color="primary" small class="mr-1">mdi-close-circle</v-icon>
								<translate>Cancel</translate>
							</v-btn>
						</template>
					</v-col>
				</v-row>
				<v-row no-gutters class="mt-2">
					<v-col cols="2" style="height: 630px">
						<v-expansion-panels v-model="groupPanel">
							<v-expansion-panel key="1">
								<v-expansion-panel-header class="text-subtitle-1 font-weight-bold secondary">
									<translate>Points</translate>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list :disabled="loading">
										<v-list-item-group color="primary" v-model="selectedClassicGroups" multiple>
											<v-list-item
												v-for="group in classicGroups"
												:key="group.id"
												:value="group.id"
												@click="filterPoints(group.id)"
											>
												<v-list-item-content>
													<v-list-item-title v-if="group.name == 'Todos'"><translate>All</translate></v-list-item-title>
													<v-list-item-title v-else v-text="group.name"></v-list-item-title>
												</v-list-item-content>
												<v-list-item-action v-if="admin && group.name != 'Todos'" class="ma-0">
													<v-btn icon @click.stop="setGroupToEdit(group.id)" style="z-index: 300">
														<v-icon color="primary">mdi-cog</v-icon>
													</v-btn>
												</v-list-item-action>
											</v-list-item>
										</v-list-item-group>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel key="2">
								<v-expansion-panel-header class="text-subtitle-1 font-weight-bold secondary">
									<translate>Treatments</translate>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<p v-if="customGroups.length == 0" class="font-weight-thin ma-3" v-translate>No treatments.</p>
									<v-list v-else>
										<v-list-item-group color="primary" v-model="selectedCustomGroups" multiple>
											<v-list-item
												v-for="group in customGroups"
												:key="group.id"
												:value="group.id"
												@click="clickCustomGroup(group.id)"
											>
												<v-list-item-content>
													<v-list-item-title v-text="group.name"></v-list-item-title>
												</v-list-item-content>
												<v-list-item-action v-if="group.name != 'Meus'" class="ma-0">
													<v-btn icon @click.stop="setGroupToEdit(group.id)" style="z-index: 300">
														<v-icon color="primary">mdi-cog</v-icon>
													</v-btn>
												</v-list-item-action>
											</v-list-item>
										</v-list-item-group>
									</v-list>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
						<v-dialog v-model="showNewGroup" max-width="40%" persistent scrollable>
								<v-card>
									<v-card-title class="text-subtitle-2 primary--text mb-2 secondary">
										<translate>New Treatment</translate>
									</v-card-title>
									<v-card-text>
										<v-form ref="newGroupForm">
											<v-text-field
												v-model="newGroup.name"
												:label="$gettext('Name')"
												filled
												:rules="[required]"
												class="text-caption"
											></v-text-field>
											<!-- <v-row no-gutters align="center" justify="center">
												<v-col cols="12">
													<v-color-picker v-model="newGroup.color" flat class="ma-2" hide-canvas hide-inputs></v-color-picker>
												</v-col>
											</v-row> -->
											<v-row no-gutters>
												<v-col cols="12">
													<span v-translate class="text-body-2 font-weight-bold">Points</span>
												</v-col>
												<v-col cols="12" class="mt-2">
													<SearchPoints @add-point="addPointToGroup($event, newGroup)" :auricular="auricular" />
													<p v-if="newGroup.points.length == 0" class="font-weight-thin ml-2 mt-2" v-translate>No points.</p>
													<AcuPointList v-else :list="newGroup.points" @remove-point="removePointFromGroup($event, newGroup)" />
												</v-col>
											</v-row>
										</v-form>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-btn small color="primary darken-1" text @click="showNewGroup = false">
											<translate>Cancel</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn small color="primary darken-1" text @click="createGroup" :loading="loading">
											<translate>Create</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
						</v-dialog>
						<v-dialog v-model="showEditGroup" max-width="40%" persistent scrollable>
								<v-card v-if="groupToEdit">
									<v-card-title class="text-subtitle-2 primary--text mb-2 secondary">
										<translate>Edit Treatment</translate>
									</v-card-title>
									<v-card-text class="text-caption" v-if="groupToEdit">
										<v-form ref="groupForm">
											<v-text-field
												v-model="groupToEdit.name"
												:label="$gettext('Name')"
												filled
												:rules="[required]"
												class="text-caption"
											></v-text-field>
											<!-- <v-row no-gutters align="center" justify="center">
												<v-col cols="12">
													<v-color-picker v-model="groupToEdit.color" flat class="ma-2" hide-canvas hide-inputs></v-color-picker>
												</v-col>
											</v-row> -->
											<v-row no-gutters>
												<v-col cols="12">
													<span v-translate class="text-body-2 font-weight-bold">Points</span>
												</v-col>
												<v-col cols="12" class="mt-2">
													<SearchPoints @add-point="addPointToGroup($event, groupToEdit)" :auricular="auricular" />
													<p v-if="groupToEdit.points.length == 0" class="font-weight-thin ml-2" v-translate>No points.</p>
													<AcuPointList v-else :list="groupToEdit.points" @remove-point="removePointFromGroup($event, groupToEdit)" />
												</v-col>
											</v-row>
										</v-form>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-btn small color="primary" text @click="groupToEdit = null; showEditGroup = false">
											<translate>Cancel</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn small color="primary" text @click="deleteGroup" :loading="loading">
											<v-icon class="mr-1">mdi-delete-circle</v-icon>
											<translate>Delete</translate>
										</v-btn>
										<v-btn small color="primary" text @click="editGroup" :loading="loading">
											<translate>Save</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
						</v-dialog>
						<v-dialog v-model="showNewPoint" max-width="30%" persistent>
								<v-card>
									<v-card-title class="text-subtitle-2 primary--text mb-2 secondary">
										<translate>New Point</translate>
									</v-card-title>
									<v-card-text>
										<v-form ref="newPointForm">
											<v-text-field
												v-model="newPoint.name"
												:label="$gettext('Name')"
												filled
												:rules="[required]"
												class="text-caption"
											></v-text-field>
											<p>
												<span v-translate class="font-weight-bold">Side</span> - 
												<span key="bilateral" v-if="doublePoint" v-translate>Bilateral</span>
												<template v-else>
													<span key="left" v-if="newPoint.side == 'left'" v-translate>Left</span>
													<span key="right" v-else-if="newPoint.side == 'right'" v-translate>Right</span>
													<span key="center" v-else v-translate>Center</span>
												</template>
											</p>
											<v-checkbox
												v-if="newPoint.side != 'center'"
												v-model="doublePoint"
												class="mt-0 pt-0"
												color="primary"
												dense
												label="Criar ponto lateral oposto"
												@change="drawMirrorPoint"
											>
											</v-checkbox>
										</v-form>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-btn small color="primary darken-1" text @click="cancelCreatePoint">
											<translate>Cancel</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn small color="primary darken-1" text @click="createPoint">
											<translate>Create</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
						</v-dialog>
						<v-dialog v-model="showPointInfo" max-width="20%" persistent>
								<v-card v-if="pointToEdit">
									<v-card-title class="text-subtitle-2 primary--text mb-3 secondary">
										<v-icon small color="primary" class="mr-1">$vuetify.icons.acuIcon</v-icon>
										<translate>Point</translate>
									</v-card-title>
									<v-card-text class="text-caption pb-3">
										<template v-if="!showEditPoint">
											<p>Nome <span class="font-weight-light">{{pointToEdit.name}}</span></p>
											<p>Lateralidade <span class="font-weight-light">{{getSide(pointToEdit.side)}}</span></p>
											<!-- <p class="mb-1">Descrição</p>
											<span class="font-weight-light">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book</span> -->
											<p class="mt-2 mb-1">Grupos</p>
											<p v-if="pointToEdit.groups.length == 0" class="font-weight-thin ml-2" v-translate>No groups.</p>
											<v-chip class="font-weight-light mr-1" small v-for="g in pointToEdit.groups" :key="g.id">{{g.name}}</v-chip>
										</template>
										<template v-else>
											<v-form ref="pointForm">
												<v-text-field
													v-model="pointToEdit.name"
													:label="$gettext('Name')"
													filled
													:rules="[required]"
												></v-text-field>
												<v-select
													disabled
													:items="pointSides"
													v-model="pointToEdit.side"
													filled
													:label="$gettext('Side')"
													item-text="name"
													item-value="code"
												></v-select>
											</v-form>
										</template>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-btn small color="primary" text @click="showPointInfo = false; showEditPoint = false">
											<translate>Close</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<template v-if="pointToEdit.custom">
											<v-btn key="edit-point" v-if="!showEditPoint" small color="primary" text @click="showEditPoint = true" :loading="loading">
												<translate>Edit</translate>
											</v-btn>
											<template v-else>
												<v-btn key="delete-point" small color="primary" text @click="deletePoint" :loading="loading">
													<v-icon small class="mr-1">mdi-delete-circle</v-icon>
													<translate>Delete</translate>
												</v-btn>
												<v-btn key="save-point" small color="primary" text @click="editPoint" :loading="loading">
													<translate>Save</translate>
												</v-btn>
											</template>
										</template>
									</v-card-actions>
								</v-card>
						</v-dialog>
					</v-col>
					<v-col style="height: 630px;" class="px-2">
						<v-card height="100%">
						<AcupunctureBody :key="acuBodyKey"
															ref="body" class="body"
															:technics="technics"
															:pointTechnics="pointTechnics"
															:selectedGroups="selectedGroups"
															:mode="mode"
															:auricular="auricular"
															:createMode="createMode"
															@new-point="showNewPointForm"
															@show-point-info="setPointToEdit"
															@select-all-group="groupPanel = 0"/>
						</v-card>
					</v-col>
					<v-col cols="3" style="height: 630px;">
						<v-card height="100%" style="display: flex; flex-direction: column;">
							<v-card-title class="text-subtitle-1 font-weight-bold">
								<translate>Points</translate>
								<v-spacer></v-spacer>
								<v-btn icon :disabled="loading" @click="showSearch = !showSearch">
									<v-icon v-if="showSearch" color="primary">mdi-magnify-close</v-icon>
									<v-icon v-else color="primary">mdi-magnify</v-icon>
								</v-btn>
								<v-btn icon :disabled="selectedPoints.length == 0 || loading" @click="showRemoveAllPoints = true">
									<v-icon color="primary">mdi-delete-alert</v-icon>
									<DeleteConfirmationDialog v-model="showRemoveAllPoints" item="points" @delete="removeAllPoints" />
								</v-btn>
							</v-card-title>
							<v-card-text style="flex-grow: 1; overflow: auto;">
								<v-row v-if="showSearch" no-gutters class="mb-2">
									<v-col cols="12">
										<SearchPoints @add-point="addPoint" :auricular="auricular" />
									</v-col>
								</v-row>
								<p v-if="selectedPoints.length == 0" class="font-weight-thin" v-translate>No points selected.</p>
								<AcuPointList v-else :list="selectedPoints" @remove-point="removePoint" :grid="true" :edit="true" :graphic="true"/>
							</v-card-text>
							<v-footer class="pa-2" color="white"></v-footer>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn color="primary" text @click="cancel" :disabled="loading">
					<translate>Cancel</translate>
				</v-btn>
				<v-progress-circular
					v-if="loading"
					:size="30"
					color="primary"
					indeterminate
					class="ml-2"
				></v-progress-circular>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" text @click="clickCreateGroup" :disabled="loading">
					<span v-if="admin" v-translate>Save Points Group</span>
					<span v-else v-translate>Save Treatment</span>
				</v-btn>
				<v-btn color="primary darken-1" text @click="conclude" :disabled="loading">
					<translate>Conclude</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import AcupunctureBody from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureBody.vue";
import AcuPointList from "@/components/acupuncture/AcuPointList.vue";
import SearchPoints from "@/components/appointment/treatments/tcm/acupuncture/SearchPoints.vue";
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";

export default {
  name: "AcupunctureGraphicMode",
  props: ["show", "auricular", "admin", "createMode", "inAppointment"],
  components: {
		AcupunctureBody,
		AcuPointList,
		SearchPoints,
		DeleteConfirmationDialog
  },
	data: () => ({
		acuBodyKey: 1,
		pointTechnics: [1],
		selectedClassicGroups: [],
		selectedCustomGroups: [],
		mode: 'select',
		showSearch: false,
		showRemoveAllPoints: false,
		showPointInfo: false,
		showEditPoint: false,
		pointToEdit: null,
		showNewPoint: false,
		newPoint: {
			name: "",
			side: "left"
		},
		doublePoint: false,
		showNewGroup: false,
		newGroup: {
			name: "",
			//color: "",
			custom: true,
			points: []
		},
		showEditGroup: false,
		groupToEdit: null,
		groupPanel: null
	}),
	computed: {
		technics() {
			let technics = [
        {id: 1, name: this.$gettext("Acupuncture"), icon: '$vuetify.icons.acuIcon', acu: true, auricular: true},
        {id: 2, name: this.$gettext("Moxa"), icon: '$vuetify.icons.acuTechnic4', acu: true, auricular: true},
        {id: 3, name: this.$gettext("Bleeding"), icon: '$vuetify.icons.acuTechnic1', acu: true, auricular: true},
        {id: 4, name: this.$gettext("Cupping"), icon: '$vuetify.icons.acuTechnic3', acu: true, auricular: false},
        {id: 5, name: this.$gettext("Electro"), icon: '$vuetify.icons.acuTechnic2', acu: true, auricular: true},
        {id: 6, name: this.$gettext("Magnetic Sphere"), icon: 'mdi-circle-slice-8', acu: false, auricular: true},
        {id: 7, name: this.$gettext("Seeds"), icon: 'mdi-circle-medium', acu: false, auricular: true},
        {id: 8, name: this.$gettext("ASP"), icon: 'mdi-arrow-down-bold', acu: false, auricular: true},
        {id: 9, name: this.$gettext("TDP"), icon: 'mdi-white-balance-sunny', acu: true, auricular: false}
      ]
			if(this.auricular) return technics.filter(t => t.auricular);
      else return technics.filter(t => t.acu);
			//return this.$store.getters.acuTechnics(this.auricular);
		},
		selectedPoints() {
			return this.$store.getters.acuPoints(this.auricular);
		},
		classicGroups() {
			return this.$store.getters.acuClassicGroups(this.auricular);
		},
		customGroups() {
			return this.$store.getters.acuCustomGroups(this.auricular);
		},
		loading() {
			return this.$store.getters.acuLoading;
		},
		selectedGroups() {
			return this.selectedClassicGroups.concat(this.selectedCustomGroups);
		},
		required() {
			return value => !!value || this.$gettext("Required.");
		},
		pointSides() {
			return [
				{name: this.$gettext('Left'), code: "left"},
				{name: this.$gettext('Right'), code: "right"},
				{name: this.$gettext('Center'), code: "center"}
			]
		}
	},
	methods: {
		filterPoints(id) {
			console.log("FILTER");
			let component = this; 
			setTimeout(function() {
				let body = component.$refs.body;
				if(id == 21) {
					component.selectedClassicGroups = [21];
					body.showAll();
				} else {
					var index = component.selectedClassicGroups.indexOf(21);
					if (index !== -1) {
						component.selectedClassicGroups.splice(index, 1);
					}
					let data = {
						filter: "union",
						groups: component.selectedGroups
					}
					component.$store.dispatch("GET_VISIBLE_POINTS", data).then(points => {
						body.setVisiblePoints(points);
					});
				}
			}, 50);
		},
		clickCustomGroup(id) {
			for(let i = 0; i < this.selectedCustomGroups.length; i++) {
				if(this.selectedCustomGroups[i] == id) {
					this.removeCustomGroup(id);
					return 0;
				}
			}
			this.aplyCustomGroup(id);
			return 0;
		},
		aplyCustomGroup(id) {
			console.log("APLY CUSTOM GROUP");
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "aply_custom_group",
				group_id: id
			}
			let body = this.$refs.body;
			this.$store.dispatch("APLY_CUSTOM_GROUP", data).then(points => {
				body.selectPoints(points);
			});
		},
		removeCustomGroup(id) {
			console.log("REMOVE CUSTOM GROUP");
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "remove_custom_group",
				group_id: id
			}
			let body = this.$refs.body;
			this.$store.dispatch("REMOVE_CUSTOM_GROUP", data).then(points => {
				body.deselectAndHidePoints(points);
			});
		},
		selectAllPoints() {
			let body = this.$refs.body;
			body.addAllPoints();
		},
		removePoint(point) {
			let body = this.$refs.body;
			body.removePointFromList(point.id);
		},
		removeAllPoints() {
			let appointment;
			if(this.createMode) appointment = -1;
			else appointment = this.$route.params.aid;
			let data = {
				appointment: appointment,
				op: "remove_all_points",
				auricular: this.auricular
			}
			let body = this.$refs.body;
			this.$store.dispatch("REMOVE_ALL_POINTS", data).then(() => {
				body.deselectAll();
				body.hideAll();
				this.selectedCustomGroups = [];
				this.selectedClassicGroups = [];
				this.showRemoveAllPoints = false;
			});
		},
		clickCreateGroup() {
			this.newGroup = {
				name: "",
				color: "",
				auricular: this.auricular,
				points: JSON.parse(JSON.stringify(this.selectedPoints))
			}
			this.showNewGroup = true;
		},
		createGroup() {
			if(this.$refs.newGroupForm.validate()) {
				if(this.admin) this.newGroup.custom = false;
				else this.newGroup.custom = true;
				this.$store.dispatch("CREATE_GROUP", this.newGroup).then(() => {
					this.showNewGroup = false;
				});
			}
		},
		editGroup() {
			if(this.$refs.groupForm.validate()) {
				this.groupToEdit.form = false;
				this.$store.dispatch("EDIT_GROUP", this.groupToEdit).then(() => {
					this.groupToEdit = null;
					this.showEditGroup = false;
				});
			}
		},
		addPointToGroup(point, group) {
			let exist = group.points.find(p => p.id === point.id);
			if(exist) console.log("already in");
			else {
				point.technics = this.pointTechnics;
				group.points.push(point);
			}
		},
		removePointFromGroup(point, group) {
			group.points.splice(group.points.indexOf(point), 1);
		},
		deleteGroup() {
			this.$store.dispatch("DELETE_GROUP", this.groupToEdit).then(() => {
				this.groupToEdit = null;
				this.showEditGroup = false;
			});
		},
		addPoint(point) {
			this.$refs.body.addPointFromSearch(point.id);
		},
		showNewPointForm(side) {
			this.newPoint.side = side;
			this.doublePoint = false;
			this.showNewPoint = true;
		},
		drawMirrorPoint() {
			console.log("DRAW MIRROR");
			if(this.doublePoint) this.$refs.body.drawMirrorPoint();
			else this.$refs.body.removeMirrorPoint();
		},
		createPoint() {
			if(this.$refs.newPointForm.validate()) {
				let data = [];
				let point = {
					name: this.newPoint.name,
					cx: this.$refs.body.getNewPointCX(),
					cy: this.$refs.body.getNewPointCY(),
					side: this.newPoint.side,
					auricular: this.auricular,
					custom: this.admin ? false : true
				}
				data.push(point);
				if(this.doublePoint) {
					let mirrorPoint = {
						name: this.newPoint.name,
						cx: this.$refs.body.getNewPointMirrorCX(),
						cy: this.$refs.body.getNewPointMirrorCY(),
						side: this.newPoint.side == 'left' ? 'right' : 'left',
						auricular: this.auricular,
						custom: this.admin ? false : true
					}
					data.push(mirrorPoint);
				}
				console.log(data);
				//if(this.admin) data.custom = false;
				this.$store.dispatch("CREATE_POINT", data).then((points) => {
					this.confirmCreatePoint(points);
				}).catch(() => {
					this.cancelCreatePoint();
				});
			}
		},
		editPoint() {
			if(this.$refs.pointForm.validate()) {
				this.pointToEdit.form = false;
				this.$store.dispatch("EDIT_POINT", this.pointToEdit).then(() => {
					this.showEditPoint = false;
				});
			}
		},
		deletePoint() {
			let body = this.$refs.body;
			this.$store.dispatch("DELETE_POINT", this.pointToEdit).then(() => {
				body.deletePoint(this.pointToEdit.id);
				this.pointToEdit = null;
				this.showPointInfo = false;
				this.showEditPoint = false;
			});
		},
		confirmCreatePoint(points) {
			this.$refs.body.confirmDrawnPoint(points);
			this.showNewPoint = false;
			this.mode = 'select';
		},
		cancelCreatePoint() {
			this.$refs.body.removeDrawnPoint();
			this.doublePoint = false;
			this.showNewPoint = false;
		},
		setPointToEdit(id) {
			this.showPointInfo = true;
			this.$store.dispatch("GET_POINT_INFO", {id: id, form: false}).then((point) => {
				this.pointToEdit = point;
			});
		},
		setGroupToEdit(id) {
			this.showEditGroup = true;
			this.$store.dispatch("GET_GROUP_INFO", {id: id, form: false}).then((group) => {
				this.groupToEdit = group;
			});
		},
		getSide(side) {
			if (side === "left") return this.$gettext("Left");
			else if (side === "right") return this.$gettext("Right");
			else return this.$gettext("Center");
		},
		conclude() {
			if(this.inAppointment) {
				let data = {
					appointment: this.$route.params.aid,
					op: "save_points",
					auricular: this.auricular,
					points: this.selectedPoints
				}
				this.$store.dispatch("SAVE_ACU_POINTS", data).then(() => {this.$emit('close')});
			} else {
				this.$emit('close');
			}
		},
		cancel() {
			if(this.inAppointment) {
				let data = {
					appointment: this.$route.params.aid,
					op: "get_selected_points"
				}
				this.$store.dispatch("GET_ACU_POINTS", data).then(() => {this.$emit('close')});
			} else {
				this.$emit('close');
			}
		}
	},
	watch: {
		show(open) {
			if(open) {
				this.selectedClassicGroups = [];
				this.selectedCustomGroups = [];
				this.pointTechnics = [1];
				this.groupPanel = null;
				this.mode = "select";
				//this.acuBodyKey++;
			}
		},
		groupPanel(panel) {
			if(panel == 0) {
				this.selectedClassicGroups = [this.classicGroups[0].id];
				this.$refs.body.showAll();
			}
			if(panel == 1) {
				this.$refs.body.hideAll();
			}
		}
	}
}
</script>

<style scoped>
>>>.v-expansion-panel-content__wrap {
	padding: 0px
}
</style>